module.exports = __webpack_public_path__ + "img/index_banner03.dbc086fe.jpg";